import React from "react";
import {
  Datagrid,
  List,
  TextField,
  TextInput,
  
  
  
  Edit,
  
  SimpleForm,
  BooleanInput,
  NumberInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceInput,
  SelectInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from "react-admin";

export const FileList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" label="image Name" />
        <TextField source="s3Url" />

        <ReferenceArrayField
          label="Mindfulness"
          reference="Mindfulness"
          source="mindfulness.id"
        >
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
      </Datagrid>
    </List>
  );
};

const FileFormInput = ({ ...props }) => {
  return (
    <SimpleForm {...props} warnWhenUnsavedChanges>
      <TextInput source="name" label="image Name" />
      <TextInput source="s3Url" />

      <TextInput source="mindTitle" label="Ses Başlığı" />
      <TextInput source="time" label="Ses Süresi" />

      <BooleanInput source="isFree" />

      <ReferenceArrayInput
        label="Mindfulness Audio"
        reference="Mindfulness"
        source="mindAudioIds"
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
      <ReferenceInput
        label="Image for Mindfulness"
        source="mindfulnessImage.id"
        reference="Mindfulness"
      >
        <SelectInput optionText="name" />
      </ReferenceInput>


         <ReferenceInput
        label="Image for Blog"
        source="blogImage.id"
        reference="Blog"
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Image for Category"
        source="categoryImage.id"
        reference="Category"
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Image for User Profil"
        source="userProfilePic.id"
        reference="User"
      >
        <SelectInput optionText="email" />
      </ReferenceInput>
      <TextInput source="url" label="Old Url" />
      <TextInput source="contentType" />
      <TextInput source="secret" />
      <NumberInput source="size" />
    </SimpleForm>
  );
};
export const FileEdit = (props) => (
  <Edit {...props}>
    <FileFormInput />
  </Edit>
);
